import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "65",
  height: "66",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F5F5F5",
      d: "M0 10.898c0-5.522 4.477-10 10-10h45c5.523 0 10 4.478 10 10v44.794c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".3",
      d: "M48.265 30.302a10.4 10.4 0 0 1 1.244 5.016c-.044 5.838-4.95 10.513-10.891 10.513H27.941v3.145c0 1.49-1.765 2.14-2.764 1.16l-5.392-5.298a1.58 1.58 0 0 1-.474-1.124c0-.422.17-.826.474-1.124l5.392-5.298c1.018-1 2.764-.287 2.764 1.126v3.179h10.707c3.56 0 6.51-2.794 6.546-6.291a6.2 6.2 0 0 0-.62-2.786 1.56 1.56 0 0 1 .323-1.806c.32-.312.582-.566.8-.781a1.643 1.643 0 0 1 2.071-.178 1.6 1.6 0 0 1 .496.547"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "m19.612 39.763-.8.78a1.644 1.644 0 0 1-2.071.178 1.6 1.6 0 0 1-.496-.546A10.4 10.4 0 0 1 15 35.158c.045-5.837 4.95-10.517 10.892-10.517h10.676v-3.14c0-1.476 1.752-2.15 2.763-1.16l5.392 5.297c.304.298.474.703.474 1.124s-.17.826-.474 1.124l-5.392 5.298c-1 .983-2.763.325-2.763-1.156v-3.149H25.86c-3.56 0-6.509 2.794-6.546 6.291-.01.962.202 1.913.621 2.782a1.56 1.56 0 0 1-.323 1.81"
    }, null, -1)
  ])))
}
export default { render: render }